export const profileRoutes = [
  {
    path: "/profile",
    name: "Profile",
    component: () => import("@/views/Profile.vue"),
    redirect: { name: "ProfileBase" },
    meta: { topLevel: true, menu: true },
    children: [
      {
        path: "base",
        name: "ProfileBase",
        component: () => import("@/views/Profile/Base.vue"),
      },
      {
        path: "security",
        name: "ProfileSecurity",
        component: () => import("@/views/Profile/Security.vue"),
      },
      {
        path: "settings",
        name: "ProfileSettings",
        component: () => import("@/views/Profile/Settings.vue"),
      },
    ],
  },
  {
    path: "/profile/security/need2fa",
    name: "ProfileSecurityNeed2Fa",
    component: () => import("@/views/Profile/Security/Need2Fa.vue"),
  },
  {
    path: "/profile/security/enable2fa",
    name: "ProfileSecurityEnable2Fa",
    component: () => import("@/views/Profile/Security/Enable2Fa.vue"),
  },
  {
    path: "/profile/security/enable2faPhone",
    name: "ProfileSecurityEnable2FaPhone",
    component: () => import("@/views/Profile/Security/Enable2FaPhone.vue"),
  },
  {
    path: "/profile/security/needphone",
    name: "ProfileSecurityNeedPhone",
    component: () => import("@/views/Profile/Security/NeedPhone.vue"),
  },
  {
    path: "/profile/security/verifyphone",
    name: "ProfileSecurityVerifyPhone",
    component: () => import("@/views/Profile/Security/VerifyPhone.vue"),
  },
  {
    path: "/profile/security/needemail",
    name: "ProfileSecurityNeedEmail",
    component: () => import("@/views/Profile/Security/NeedEmail.vue"),
    meta: { showDemoVersion: true },
  },
  {
    path: "/profile/security/verifyemail",
    name: "ProfileSecurityVerifyEmail",
    component: () => import("@/views/Profile/Security/VerifyEmail.vue"),
    meta: { public: true, showDemoVersion: true },
  },
  {
    path: "/profile/security/confirmemail",
    name: "ProfileSecurityConfirmEmail",
    component: () => import("@/views/Profile/Security/ConfirmEmail.vue"),
    meta: { showDemoVersion: true, back: { to: "ProfileSecurity" } },
  },
];
